// import React, { useEffect, useRef, useState } from "react";
// import { InamdarHospiLogo } from "../../assets/printAssets/InmadarHospiLogo";
// import { GeneratePrint } from "../../common/components/printModal/GeneratePrint";
// import { getPatientEmrPatch } from "../services/emrServices/EMRServices";

// function EMRPrescriptionPrint({ selectedRow }) {
//   const printRef = useRef(null);

//   const [dataResult, setDataResult] = useState(null);

//   useEffect(() => {
//     getPatientEmrPatch(
//       0,
//       selectedRow?.VisitId,
//       selectedRow?.["Doctor Id"],
//       false
//     )
//       .then((response) => response.data)
//       .then((res) => {
//         setDataResult(res.result[0]);
//       })
//       .catch((err) => err);
//   }, [selectedRow.VisitId]);

//   useEffect(() => {
//     dataResult && printRef && GeneratePrint(printRef);
//   }, [dataResult]);

//   return (
//     <div ref={printRef}>
//       <table
//         className="w-full"
//         style={{
//           "-fs-table-paginate": "paginate",
//         }}
//       >
//         <thead>
//           <div className=" text-center -mt-11">
//             <div className=" flex justify-end">
//               <InamdarHospiLogo />
//             </div>
//             <div className=" -mt-16">
//               <h1 className=" font-bold text-[17px]">
// CIMET's Inamdar Multispeciality Hospital                  </h1>
//               <h1 className=" text-[14px] ">
//                 Sr. No 15, Fatimanagar, Behind Kpct Mall Pune - 411 040.
//               </h1>
//             </div>
//           </div>

//           <div className="p-1 border-t-[1px] border-b-[1px] border-black grid grid-cols-[18%_1%_31%_14%_1%_35%]">
//             <div className=" font-semibold text-[14px]">Patient Name</div>
//             <div className="font-semibold text-[14px]">:</div>
//             <div className="text-[14px]">{selectedRow?.["Patient Name"]}</div>
//             <div className=" font-semibold text-[14px]">Age:</div>
//             <div className="font-semibold text-[14px]">:</div>
//             <div className="text-[14px]">{selectedRow?.AgeYear}</div>
//             <div className=" font-semibold text-[14px]">Date</div>
//             <div className="font-semibold text-[14px]">:</div>
//             <div className="text-[14px]">{selectedRow?.Date}</div>
//             <div className=" font-semibold text-[14px]">MRNo</div>
//             <div className="font-semibold text-[14px]">:</div>
//             <div className="text-[14px]">{selectedRow?.MRNo}</div>
//             <div className=" font-semibold text-[14px]">Department</div>
//             <div className="font-semibold text-[14px]">:</div>
//             <div className="text-[14px]">{selectedRow?.Department}</div>
//             <div className=" font-semibold text-[14px]">Doctor Name</div>
//             <div className="font-semibold text-[14px]">:</div>
//             <div className="text-[14px]">{selectedRow?.["Doctor Name"]}</div>
//           </div>
//         </thead>
//         <tbody>
//           <div className="mt-2 p-1 space-y-5">
//             <div>
//               <h2 className="text-[14px] font-bold">Vitals</h2>
//               <div className="text-[14px] ml-2 grid grid-cols-4">
//                 <div className="grid grid-cols-[30%_70%]">
//                   <h3>Temp</h3>
//                   <p>
//                     : <span>{dataResult?.temp || ""}</span>
//                   </p>
//                 </div>
//                 <div className="grid grid-cols-[30%_70%]">
//                   <h3>Spo2</h3>
//                   <p>
//                     : <span>{dataResult?.spo2 || ""}</span>
//                   </p>
//                 </div>
//                 <div className="grid grid-cols-[30%_70%]">
//                   <h3 className="uppercase">bp</h3>
//                   <p>
//                     : <span>{dataResult?.bp || ""}</span>
//                   </p>
//                 </div>
//                 <div className="grid grid-cols-2">
//                   <h3>Respiration</h3>
//                   <p>
//                     : <span>{dataResult?.respiration || ""}</span>
//                   </p>
//                 </div>
//                 <div className="grid grid-cols-[30%_70%]">
//                   <h3 className="uppercase">bsl</h3>
//                   <p>
//                     : <span>{dataResult?.bsl}</span>
//                   </p>
//                 </div>
//                 <div className="grid grid-cols-[30%_70%]">
//                   <h3>Height</h3>
//                   <p>
//                     : <span>{dataResult?.height || ""}</span>
//                   </p>
//                 </div>
//                 <div className="grid grid-cols-[30%_70%]">
//                   <h3>Weight</h3>
//                   <p>
//                     : <span>{dataResult?.weight || ""}</span>
//                   </p>
//                 </div>
//                 <div className="grid grid-cols-2">
//                   <h3 className="uppercase">bmi</h3>
//                   <p>
//                     : <span>{dataResult?.bmi || ""}</span>
//                   </p>
//                 </div>
//               </div>
//             </div>
//             <div>
//               {dataResult?.emrDiagnosis && (
//                 <div className="text-[14px]">
//                   <h2 className="font-semibold">Diagnosis</h2>
//                   <div className="">
//                     {JSON.parse(dataResult?.emrDiagnosis).map(
//                       (digno, index) => (
//                         <ul key={index}>
//                           {/* <li className="ml-2">{`${digno?.description} ${
//                             digno.since || digno?.description !== "" ? ":" : ""
//                           } ${
//                             digno.since
//                               ? `Since ${digno.since} ${digno.duration}`
//                               : ""
//                           }`}</li> */}
//                           <li className="ml-2">{digno?.description}</li>
//                         </ul>
//                       )
//                     )}
//                   </div>
//                 </div>
//               )}
//             </div>
//             <div>
//               {dataResult?.emrComplaints && (
//                 <div className="text-[14px]">
//                   <h2 className="font-semibold">Complaints</h2>
//                   <div className="">
//                     {JSON.parse(dataResult?.emrComplaints).map(
//                       (complaint, index) => (
//                         <ul key={index}>
//                           <li className="ml-2">{`${complaint?.complaint} ${
//                             complaint.since || complaint?.description !== ""
//                               ? ":"
//                               : ""
//                           } ${
//                             complaint.since
//                               ? `Since ${complaint.since} ${complaint.duration}`
//                               : ""
//                           } ${
//                             complaint?.description !== ""
//                               ? `(${complaint?.description})`
//                               : ""
//                           }`}</li>
//                         </ul>
//                       )
//                     )}
//                   </div>
//                 </div>
//               )}
//             </div>
//             <div>
//               {dataResult?.emrAllergies && (
//                 <div className="text-[14px]">
//                   <h2 className="font-semibold">Allergy</h2>
//                   <div>
//                     {JSON.parse(dataResult?.emrAllergies).map((alg, index) => (
//                       <ul key={index}>
//                         <li className="ml-2">{alg?.description}</li>
//                       </ul>
//                     ))}
//                   </div>
//                 </div>
//               )}
//             </div>
//             <div className="grid grid-cols-2 w-full gap-x-2">
//               {dataResult?.emrPastHistory && (
//                 <div className="text-[14px]">
//                   <h2 className="font-semibold">Past History</h2>
//                   <div>
//                     {JSON.parse(dataResult?.emrPastHistory).map(
//                       (past, index) => (
//                         <ul key={index}>
//                           <li className="ml-2">{`${past?.historyDesc} ${
//                             past.since || past?.description !== "" ? ":" : ""
//                           } ${
//                             past.since
//                               ? `Since ${past.since} ${past.duration}`
//                               : ""
//                           } ${
//                             past?.description !== ""
//                               ? `(${past?.description})`
//                               : ""
//                           }`}</li>
//                         </ul>
//                       )
//                     )}
//                   </div>
//                 </div>
//               )}
//               {dataResult?.emrFamilyHistory && (
//                 <div className="text-[14px]">
//                   <h2 className="font-semibold">Family History</h2>
//                   <div>
//                     {JSON.parse(dataResult?.emrFamilyHistory).map(
//                       (family, index) => (
//                         <ul key={index}>
//                           <li className="ml-2">{`${family?.historyDesc} ${
//                             family.since || family?.description !== ""
//                               ? ":"
//                               : ""
//                           } ${
//                             family.since
//                               ? `Since ${family.since} ${family.duration}`
//                               : ""
//                           } ${
//                             family?.description !== ""
//                               ? `(${family?.description})`
//                               : ""
//                           }`}</li>
//                         </ul>
//                       )
//                     )}
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//           {dataResult?.emrOldMedications && (
//             <div className="-space-y-1">
//               <label className="text-[14px] font-semibold">
//                 Old Medications
//               </label>
//               <table className="w-full border-collapse my-5">
//                 <thead className="table-header-group">
//                   <tr className="border-b-[1px] border-t-[1px] font-semibold font-Poppins border-black text-start">
//                     <th className="w-[40%] text-[12px] text-left">Drug Name</th>
//                     <th className="w-[40%] text-[12px] text-center">
//                       Frequency
//                     </th>
//                     <th className="w-[20%] text-[12px] text-center">IsOn</th>
//                   </tr>
//                 </thead>
//                 <tbody className="table-row-group">
//                   {JSON.parse(dataResult.emrOldMedications)
//                     ?.filter(
//                       (val) =>
//                         val?.drug_name !== undefined && val?.drug_name !== ""
//                     )
//                     .map((item, index) => (
//                       <React.Fragment key={index}>
//                         <tr>
//                           <td className="w-[40%] text-[12px]">
//                             <div>{item.drug_name}</div>
//                           </td>
//                           <td className="w-[40%] text-[12px] relative">
//                             <div className="absolute top-0 flex justify-center w-full">
//                               {item.frequency_name}
//                             </div>
//                           </td>
//                           <td className="w-[20%] text-[12px] relative">
//                             <div className="absolute top-0 flex justify-center w-full">
//                               {item.ison ? "On" : "Off"}
//                             </div>
//                           </td>
//                         </tr>
//                         <tr className="border border-b-black border-t-0 border-x-0">
//                           <td colSpan={3} className="text-[12px]">
//                             {item?.generic_name !== ""
//                               ? `(${item?.generic_name})`
//                               : ""}
//                           </td>
//                         </tr>
//                       </React.Fragment>
//                     ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//           {dataResult?.emrMedications && (
//             <div className="-space-y-1 mt-2">
//               <label className="text-[14px] font-semibold">
//                 Current Medications
//               </label>
//               <table className="w-full border-collapse my-5">
//                 <thead className="table-header-group">
//                   <tr className="border-b-[1px] border-t-[1px] font-semibold font-Poppins border-black text-start">
//                     <th className="w-[25%] text-[12px] text-left">Drug Name</th>
//                     <th className="w-[10%] text-[12px] text-left">Frequency</th>
//                     <th className="w-[10%] text-[12px] text-center">
//                       Duration
//                     </th>
//                     <th className="w-[10%] text-[12px] text-center">Dosage</th>
//                     <th className="w-[10%] text-[12px] text-center">
//                       Quantity
//                     </th>
//                     <th className="w-[20%] text-[12px] text-left">
//                       Instruction
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody className="table-row-group">
//                   {JSON.parse(dataResult.emrMedications).map((item, index) => (
//                     <React.Fragment key={index}>
//                       <tr className="">
//                         <td className="w-[25%] text-[12px]">
//                           <div>{item.drug_name}</div>
//                         </td>
//                         <td className="w-[10%] text-[12px] relative">
//                           <div className="absolute top-0 flex justify-center w-full">
//                             {item.frequency_name}
//                           </div>
//                         </td>
//                         <td className="w-[10%] text-[12px] relative">
//                           <div className="absolute top-0 flex justify-center w-full">
//                             {item.duration} Days
//                           </div>
//                         </td>
//                         <td className="w-[%] text-[12px] relative">
//                           <div className="absolute top-0 flex justify-center w-full">
//                             {item.dosage}
//                           </div>
//                         </td>
//                         <td className="w-[10%] text-[12px] relative">
//                           <div className="absolute top-0 flex justify-center w-full">
//                             {item.quantity}
//                           </div>
//                         </td>
//                         <td className="w-[20%] text-[12px] relative">
//                           <div className="absolute top-0 text-left">
//                             {item.instruction_name}
//                           </div>
//                         </td>
//                       </tr>
//                       <tr className="border border-b-black border-t-0 border-x-0">
//                         <td colSpan={6} className="w-[25%] text-[12px]">
//                           {item?.generic_name !== ""
//                             ? `(${item?.generic_name})`
//                             : ""}
//                         </td>
//                       </tr>
//                     </React.Fragment>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}

//           <div className="space-y-5">
//             <div>
//               {dataResult?.emrServices && (
//                 <div className="text-[14px]">
//                   <h2 className="font-semibold">Investigation</h2>
//                   <div>
//                     {JSON.parse(dataResult.emrServices)
//                       .filter(
//                         (item) => item.GroupId === 2 || item.GroupId === 32
//                       )
//                       .map((inv, index) => (
//                         <ul key={index}>
//                           <li className="ml-2">{inv.Description}</li>
//                         </ul>
//                       ))}
//                   </div>
//                 </div>
//               )}
//             </div>
//             <div>
//               {dataResult?.emrServices && (
//                 <div className="text-[14px]">
//                   <h2 className="font-semibold">Other Services</h2>
//                   <div>
//                     {JSON.parse(dataResult.emrServices)
//                       .filter(
//                         (item) => item.GroupId !== 2 && item.GroupId !== 32
//                       )
//                       .map((inv, index) => (
//                         <ul key={index}>
//                           <li className="ml-2">{inv.Description}</li>
//                         </ul>
//                       ))}
//                   </div>
//                 </div>
//               )}
//             </div>
//             <div>
//               {dataResult?.emrAdvices && (
//                 <div className="text-[14px]">
//                   <h2 className="font-semibold">Advices</h2>
//                   <div>
//                     {JSON.parse(dataResult?.emrAdvices).map((adv, index) => (
//                       <ul key={index}>
//                         <li className="ml-2">{adv.description}</li>
//                       </ul>
//                     ))}
//                   </div>
//                 </div>
//               )}
//             </div>
//             <div>
//               {dataResult?.newFollowupDate !== "" && (
//                 <div className="text-[14px]">
//                   <h2 className="font-semibold">Next Followp Date</h2>
//                   <div>{dataResult?.newFollowupDate}</div>
//                 </div>
//               )}
//             </div>
//             <div className="flex justify-end w-full pr-10">
//               <div>
//                 <div className="font-semibold">{dataResult?.Doctor}</div>
//                 <div>{dataResult?.Designation}</div>
//                 <div style={{ whiteSpace: "pre-wrap" }}>
//                   {dataResult?.PrintSignature?.replaceAll("$", "\n")}
//                 </div>
//               </div>
//             </div>
//             {/* <div>
//                             {tempDetailsObj?.instructions && (
//                                 <div>
//                                     <h2 className="font-semibold">Instruction</h2>
//                                     <div>
//                                         {tempDetailsObj?.instructions.map(
//                                             (ins, index) => (
//                                                 <ul className="px key={index}>
//                                                     <li className="list-disc">{ins}</li>
//                                                 </ul>
//                                             )
//                                         )}
//                                     </div>
//                                 </div>
//                             )}
//                         </div> */}
//           </div>
//         </tbody>
//       </table>
//     </div>
//   );
// }

// export default EMRPrescriptionPrint;

import React, { useEffect, useRef, useState } from "react";
import { InamdarHospiLogo } from "../../assets/printAssets/InmadarHospiLogo";
import { GeneratePrint } from "../../common/components/printModal/GeneratePrint";
import { getPatientEmrPatch } from "../services/emrServices/EMRServices";
import PrintRadioNABHLogo from "../../assets/icons/PrintRadioNABHLogo";
import EMRFooter from "../../assets/EMRFooter.png";

function EMRPrescriptionPrint({ selectedRow, selectedVisitRow }) {
  const printRef = useRef(null);

  const [dataResult, setDataResult] = useState(null);
  const [emrMedications, setEmrMedications] = useState([]);

  useEffect(() => {
    getPatientEmrPatch(
      0,
      selectedVisitRow !== null && selectedVisitRow !== undefined
        ? selectedVisitRow?.opdIpdId
        : selectedRow?.VisitId,
      selectedRow?.["Doctor Id"],
      false,
      0,
    )
      .then((response) => response.data)
      .then((res) => {
        setDataResult(res.result[0]);

        let matchEMRMedicationArray = JSON.parse(
          res?.result[0]?.emrMedications,
        )?.map((val) => ({
          id: val?.id ? val?.id : null,
          dosage: val?.dosage ? val?.dosage : "",
          drug_id: val?.drug_id ? val?.drug_id : null,
          drug_name: val?.drug_name ? val?.drug_name : "",
          duration: val?.duration ? val?.duration : "",
          duration_in: val?.duration_in ? val?.duration_in : "",
          form_id: val?.form_id ? val?.form_id : null,
          form_name: val?.form_name ? val?.form_name : "",
          frequency_id: val?.frequency_id ? val?.frequency_id : null,
          frequency_name: val?.frequency_name ? val?.frequency_name : "",
          generic_id: val?.generic_id ? val?.generic_id : null,
          generic_name: val?.generic_name ? val?.generic_name : "",
          instruction_id: val?.instruction_id ? val?.instruction_id : null,
          instruction_name: val?.instruction_name ? val?.instruction_name : "",
          quantity: val?.quantity ? val?.quantity : null,
          route_id: val?.route_id ? val?.route_id : null,
          route_name: val?.route_name ? val?.route_name : "",
          emr_id: val?.emr_id ? val?.emr_id : null,
        }));
        setEmrMedications(matchEMRMedicationArray);
        console.log("matchEMRMedicationArray", matchEMRMedicationArray);
      })
      .catch((err) => err);
  }, [selectedRow.VisitId]);

  useEffect(() => {
    dataResult && printRef && GeneratePrint(printRef);
  }, [dataResult]);

  console.log("emrMedications", emrMedications);

  return (
    <div ref={printRef}>
      <table
        className="w-full"
        style={{
          "-fs-table-paginate": "paginate",
        }}
      >
        <thead>
          <div className="flex justify-between items-center -mb-4">
            <div className=" flex">
              <PrintRadioNABHLogo />
            </div>
            <div className="text-center">
              <h1 className=" font-bold text-[17px]">
CIMET's Inamdar Multispeciality Hospital                 </h1>
              <h1 className=" text-[14px] ">
                Sr. No 15, Fatimanagar, Behind Kpct Mall Pune - 411 040.
              </h1>
            </div>
            <div className=" flex">
              <InamdarHospiLogo />
            </div>
          </div>
          <div className="p-1 border-t-[1px] border-b-[1px] border-black grid grid-cols-2 text-[12px]">
            <div className="flex items-center">
              <label className="font-semibold w-20">MR No</label>
              <span className="font-semibold">:&nbsp;</span>
              <label>{selectedRow?.MRNo}</label>
            </div>
            <div className="flex items-center">
              <label className="font-semibold w-20">Patient Name</label>
              <span className="font-semibold">:&nbsp;</span>
              <label>{selectedRow?.["Patient Name"]}</label>
            </div>
            <div className="flex items-center">
              <label className="font-semibold w-20">Age</label>
              <span className="font-semibold">:&nbsp;</span>
              <label>{selectedRow?.AgeYear}</label>
            </div>
            <div className="flex items-center">
              <label className="font-semibold w-20">Date</label>
              <span className="font-semibold">:&nbsp;</span>
              <label>
                {selectedVisitRow !== null && selectedVisitRow !== undefined
                  ? selectedVisitRow?.Date?.replaceAll("/", "-")
                  : selectedRow?.Date?.split(" ")[0]}
              </label>
            </div>
            <div className="flex items-center">
              <label className="font-semibold w-20">Department</label>
              <span className="font-semibold">:&nbsp;</span>
              <label>{selectedRow?.Department}</label>
            </div>
            <div className="flex items-center">
              <label className="font-semibold w-20">Doctor Name</label>
              <span className="font-semibold">:&nbsp;</span>
              <label>{selectedRow?.["Doctor Name"]}</label>
            </div>
          </div>
        </thead>
        <tbody>
          <div className="mt-2 p-1 space-y-2">
            <div className="flex space-x-1">
              <h2 className="text-[14px] font-semibold w-[16%]">Vitals</h2>
              <span className="font-semibold">:</span>
              <div className="text-[14px] flex flex-wrap w-[82%]">
                {dataResult?.temp !== null && dataResult?.temp !== "" && (
                  <div className="flex items-center">
                    <p className="font-semibold">Temp:&nbsp;</p>
                    <p>
                      {dataResult?.temp}&nbsp;{"|"}&nbsp;
                    </p>
                  </div>
                )}

                {dataResult?.spo2 !== null && dataResult?.spo2 !== "" && (
                  <div className="flex items-center">
                    <p className="font-semibold">SPO2:&nbsp;</p>
                    <p>
                      {dataResult?.spo2}&nbsp;{"|"}&nbsp;
                    </p>
                  </div>
                )}

                {dataResult?.bp !== null && dataResult?.bp !== "" && (
                  <div className="flex items-center">
                    <p className="font-semibold">BP:&nbsp;</p>
                    <p>
                      {dataResult?.bp}&nbsp;{"|"}&nbsp;
                    </p>
                  </div>
                )}
                {dataResult?.respiration !== null &&
                  dataResult?.respiration !== "" && (
                    <div className="flex items-center">
                      <p className="font-semibold">Respiration:&nbsp;</p>
                      <p>
                        {dataResult?.respiration}&nbsp;{"|"}&nbsp;
                      </p>
                    </div>
                  )}
                {dataResult?.bsl !== null && dataResult?.bsl !== "" && (
                  <div className="flex items-center">
                    <p className="font-semibold">BSL:&nbsp;</p>
                    <p>
                      {dataResult?.bsl}&nbsp;{"|"}&nbsp;
                    </p>
                  </div>
                )}
                {dataResult?.height !== null && dataResult?.height !== "" && (
                  <div className="flex items-center">
                    <p className="font-semibold">Height:&nbsp;</p>
                    <p>
                      {dataResult?.height}&nbsp;{"|"}&nbsp;
                    </p>
                  </div>
                )}
                {dataResult?.weight !== null && dataResult?.weight !== "" && (
                  <div className="flex items-center">
                    <p className="font-semibold">Weight:&nbsp;</p>
                    <p>
                      {dataResult?.weight}&nbsp;{"|"}&nbsp;
                    </p>
                  </div>
                )}
                {dataResult?.bmi !== null &&
                  dataResult?.bmi !== "" &&
                  Number(dataResult?.bmi) > 0 && (
                    <div className="flex items-center">
                      <p className="font-semibold">BMI:&nbsp;</p>
                      <p>{dataResult?.bmi}</p>
                    </div>
                  )}
              </div>
            </div>
            <div>
              {dataResult?.emrDiagnosis && (
                <div className="text-[14px] flex gap-2">
                  <div className="font-semibold w-[16%]">Diagnosis</div>
                  <span className="font-semibold">:</span>
                  <div className="flex flex-wrap w-[82%]">
                    {JSON.parse(dataResult?.emrDiagnosis).map(
                      (digno, index) => (
                        <div key={index} className="">
                          {/* <li className="ml-2">{`${digno?.description} ${
                            digno.since || digno?.description !== "" ? ":" : ""
                          } ${
                            digno.since
                              ? `Since ${digno.since} ${digno.duration}`
                              : ""
                          }`}</li> */}
                          <div className="mr-1 font-semibold">
                            {digno?.description}
                            {`${
                              JSON.parse(dataResult?.emrDiagnosis)?.length >
                                1 &&
                              index <
                                JSON.parse(dataResult?.emrDiagnosis)?.length - 1
                                ? ` |`
                                : ``
                            }`}
                          </div>
                        </div>
                      ),
                    )}
                  </div>
                </div>
              )}
            </div>
            <div>
              {dataResult?.emrComplaints && (
                <div className="text-[14px] flex gap-2">
                  <div className="font-semibold w-[16%]">Complaints</div>
                  <span className="font-semibold">:</span>
                  <div className="flex flex-wrap w-[82%]">
                    {JSON.parse(dataResult?.emrComplaints).map(
                      (complaint, index) => (
                        <div key={index}>
                          <div className="mr-1 font-semibold">
                            {`${complaint?.complaint} ${
                              complaint.since || complaint?.description !== ""
                                ? ":"
                                : ""
                            } ${
                              complaint.since
                                ? `Since ${complaint.since} ${complaint.duration}`
                                : ""
                            } ${
                              complaint?.description !== ""
                                ? `(${complaint?.description})`
                                : ""
                            }`}
                            {`${
                              JSON.parse(dataResult?.emrComplaints)?.length >
                                1 &&
                              index <
                                JSON.parse(dataResult?.emrComplaints)?.length -
                                  1
                                ? ` |`
                                : ``
                            }`}
                          </div>
                        </div>
                      ),
                    )}
                  </div>
                </div>
              )}
            </div>
            <div>
              {dataResult?.hopi !== "" && dataResult?.hopi !== null && (
                <div className="text-[14px] gap-2">
                  <div className="font-semibold">
                    History of Present Illness :
                  </div>
                  <div className="whitespace-pre-wrap">{dataResult?.hopi}</div>
                </div>
              )}
            </div>
            <div>
              {dataResult?.generalExaminations !== "" &&
                dataResult?.generalExaminations !== null && (
                  <div className="text-[14px] gap-2">
                    <div className="font-semibold ">General Examinations :</div>
                    <div className="whitespace-pre-wrap">
                      {dataResult?.generalExaminations}
                    </div>
                  </div>
                )}
            </div>
            <div>
              {dataResult?.generalExaminations !== "" &&
                dataResult?.generalExaminations !== null && (
                  <div className="text-[14px] gap-2">
                    <div className="font-semibold">
                      Systematic Examinations :
                    </div>
                    <div className="flex justify-between sapce-x-2 w-full flex-wrap">
                      <div className="whitespace-pre-wrap">
                        RS&nbsp;-&nbsp;{dataResult?.rs}
                      </div>{" "}
                      |
                      <div className="whitespace-pre-wrap">
                        CVS&nbsp;-&nbsp;{dataResult?.cvs}
                      </div>{" "}
                      |
                      <div className="whitespace-pre-wrap">
                        CNS&nbsp;-&nbsp;{dataResult?.cns}
                      </div>{" "}
                      |
                      <div className="whitespace-pre-wrap">
                        PA&nbsp;-&nbsp;{dataResult?.pa}
                      </div>{" "}
                      |
                      <div className="whitespace-pre-wrap">
                        Other&nbsp;-&nbsp;{dataResult?.seOther}
                      </div>
                    </div>
                  </div>
                )}
            </div>
            <div>
              {dataResult?.reviewOfLab !== "" &&
                dataResult?.reviewOfLab !== null && (
                  <div className="text-[14px] gap-2">
                    <div className="font-semibold">Review of Lab :</div>
                    <div className="whitespace-pre-wrap">
                      {dataResult?.reviewOfLab}
                    </div>
                  </div>
                )}
            </div>
            <div>
              {dataResult?.emrAllergies && (
                <div className="text-[14px] flex gap-2">
                  <h2 className="font-semibold w-[16%]">Allergy</h2>
                  <span className="font-semibold">:</span>
                  <div className="flex flex-wrap w-[82%]">
                    {JSON.parse(dataResult?.emrAllergies).map((alg, index) => (
                      <ul key={index}>
                        <li className="mr-1 font-semibold">
                          {alg?.description}
                          {`${
                            JSON.parse(dataResult?.emrAllergies)?.length > 1 &&
                            index <
                              JSON.parse(dataResult?.emrAllergies)?.length - 1
                              ? ` |`
                              : ``
                          }`}
                        </li>
                      </ul>
                    ))}
                  </div>
                </div>
              )}
            </div>
            {dataResult?.emrPastHistory && (
              <div className="text-[14px] flex gap-2">
                <h2 className="font-semibold w-[16%]">Past History</h2>
                <span className="font-semibold">:</span>
                <div className="flex flex-wrap w-[82%]">
                  {JSON.parse(dataResult?.emrPastHistory).map((past, index) => (
                    <div key={index}>
                      <div className="mr-1 font-semibold">
                        {`${past?.historyDesc} ${
                          past.since || past?.description !== "" ? ":" : ""
                        } ${
                          past.since
                            ? `Since ${past.since} ${past.duration}`
                            : ""
                        } ${
                          past?.description !== ""
                            ? `(${past?.description})`
                            : ""
                        }`}
                        {`${
                          JSON.parse(dataResult?.emrPastHistory)?.length > 1 &&
                          index <
                            JSON.parse(dataResult?.emrPastHistory)?.length - 1
                            ? ` |`
                            : ``
                        }`}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {dataResult?.emrFamilyHistory && (
              <div className="text-[14px] flex gap-2">
                <h2 className="font-semibold w-[16%]">Family History</h2>
                <span className="font-semibold">:</span>
                <div className="flex flex-wrap w-[82%]">
                  {JSON.parse(dataResult?.emrFamilyHistory).map(
                    (family, index) => (
                      <div key={index}>
                        <div className="mr-1 font-semibold">
                          {`${family?.historyDesc} ${
                            family.since || family?.description !== ""
                              ? ":"
                              : ""
                          } ${
                            family.since
                              ? `Since ${family.since} ${family.duration}`
                              : ""
                          } ${
                            family?.description !== ""
                              ? `(${family?.description})`
                              : ""
                          }`}
                          {`${
                            JSON.parse(dataResult?.emrFamilyHistory)?.length >
                              1 &&
                            index <
                              JSON.parse(dataResult?.emrFamilyHistory)?.length -
                                1
                              ? ` |`
                              : ``
                          }`}
                        </div>
                      </div>
                    ),
                  )}
                </div>
              </div>
            )}
          </div>
          {dataResult?.emrOldMedications && (
            <div className="-space-y-1">
              <label className="text-[14px] font-semibold">
                Old Medications
              </label>
              <table className="w-full border-collapse my-5">
                <thead className="table-header-group">
                  <tr className="border-b-[1px] border-t-[1px] font-semibold font-Poppins border-black text-start">
                    <th className="w-[40%] text-[12px] text-left">Drug Name</th>
                    <th className="w-[40%] text-[12px] text-center">
                      Frequency
                    </th>
                    <th className="w-[20%] text-[12px] text-center">IsOn</th>
                  </tr>
                </thead>
                <tbody className="table-row-group">
                  {JSON.parse(dataResult.emrOldMedications)
                    ?.filter(
                      (val) =>
                        val?.drug_name !== undefined && val?.drug_name !== "",
                    )
                    .map((item, index) => (
                      <React.Fragment key={index}>
                        <tr>
                          <td className="w-[40%] text-[12px]">
                            <div>{item.drug_name}</div>
                          </td>
                          <td className="w-[40%] text-[12px] relative">
                            <div className="absolute top-0 flex justify-center w-full">
                              {item.frequency_name}
                            </div>
                          </td>
                          <td className="w-[20%] text-[12px] relative">
                            <div className="absolute top-0 flex justify-center w-full">
                              {item.ison ? "On" : "Off"}
                            </div>
                          </td>
                        </tr>
                        <tr className="border border-b-black border-t-0 border-x-0">
                          <td colSpan={3} className="text-[12px]">
                            {item?.generic_name !== ""
                              ? `(${item?.generic_name})`
                              : ""}
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
            </div>
          )}
          {dataResult?.emrMedications && (
            <div className="-space-y-1 mt-2">
              <label className="text-[14px] font-semibold">
                Current Medications
              </label>
              <table className="w-full border-collapse my-5">
                <thead className="table-header-group">
                  <tr className="border-b-[1px] border-t-[1px] font-semibold font-Poppins border-black text-start">
                    <th className="w-[30%] text-[12px] text-left">Drug Name</th>
                    <th className="w-[15%] text-[12px] text-left">Frequency</th>
                    <th className="w-[10%] text-[12px] text-center">Dosage</th>
                    <th className="w-[15%] text-[12px] text-center">Route</th>
                    <th className="w-[10%] text-[12px] text-center">
                      Duration
                    </th>
                    {/* <th className="w-[10%] text-[12px] text-center">
                      Quantity
                    </th> */}
                    <th className="w-[20%] text-[12px] text-center">
                      Instruction
                    </th>
                  </tr>
                </thead>
                <tbody className="table-row-group">
                  {emrMedications?.map((item, index) => (
                    <React.Fragment key={index}>
                      <tr className="">
                        <td className="w-[30%] text-[12px] relative">
                          <div className="w-full">
                            {item.drug_name !== undefined &&
                            item.drug_name !== ""
                              ? item.drug_name
                              : ""}
                          </div>
                        </td>
                        <td className="w-[15%] text-[12px] relative">
                          <div className="flex justify-center text-center w-full">
                            {item.frequency_name !== undefined &&
                            item.frequency_name !== ""
                              ? item.frequency_name
                              : ""}
                          </div>
                        </td>
                        <td className="w-[10%] text-[12px] relative">
                          <div className="flex justify-center w-full">
                            {item.dosage !== undefined && item.dosage !== ""
                              ? item.dosage
                              : ""}
                          </div>
                        </td>
                        <td className="w-[15%] text-[12px] relative">
                          <div className="flex justify-center text-center w-full">
                            {item.route_name !== undefined &&
                            item.route_name !== ""
                              ? item.route_name
                              : ""}
                          </div>
                        </td>
                        <td className="w-[10%] text-[12px] relative">
                          <div className="flex justify-center text-center w-full">
                            {item.duration !== undefined && item.duration !== ""
                              ? item.duration
                              : ""}
                            Days
                          </div>
                        </td>
                        {/* <td className="w-[10%] text-[12px] relative">
                          <div className="flex justify-center w-full">
                            {item.quantity}
                          </div>
                        </td> */}
                        <td className="w-[20%] text-[12px] relative">
                          <div className="flex justify-center text-center">
                            {item.instruction_name !== undefined &&
                            item.instruction_name !== ""
                              ? item.instruction_name
                              : null}
                          </div>
                        </td>
                      </tr>
                      <tr className="border border-b-black border-t-0 border-x-0">
                        <td colSpan={6} className="w-[25%] text-[10px]">
                          {item?.generic_name !== undefined &&
                          item?.generic_name !== ""
                            ? `(${item?.generic_name})`
                            : ""}
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <div className="space-y-2">
            {dataResult?.["emrServices"] &&
            JSON.parse(dataResult?.emrServices).filter(
              (item) => item.GroupId === 2 || item.GroupId === 32,
            )?.length > 0 ? (
              <div className="">
                {dataResult?.emrServices && (
                  <div className="text-[14px] flex">
                    <h2 className="font-semibold w-[16%]">Investigation</h2>
                    <span className="font-semibold">:</span>
                    <div className="flex flex-wrap gap-2 w-[82%]">
                      {JSON.parse(dataResult.emrServices)
                        .filter(
                          (item) => item.GroupId === 2 || item.GroupId === 32,
                        )
                        .map((inv, index) => (
                          <div key={index}>
                            <div className="ml-2 font-semibold">
                              {inv?.Description || inv?.description}
                              {`${
                                JSON.parse(dataResult?.emrServices).filter(
                                  (item) =>
                                    item.GroupId === 2 || item.GroupId === 32,
                                )?.length > 1 &&
                                index <
                                  JSON.parse(dataResult?.emrServices).filter(
                                    (item) =>
                                      item.GroupId === 2 || item.GroupId === 32,
                                  )?.length -
                                    1
                                  ? "  |"
                                  : ""
                              }`}
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </div>
            ) : (
              ""
            )}

            <div>
              {dataResult?.["emrServices"] &&
                JSON.parse(dataResult.emrServices).filter(
                  (item) => item.GroupId !== 2 && item.GroupId !== 32,
                )?.length > 0 && (
                  <div className="text-[14px] flex">
                    <h2 className="font-semibold w-[16%]">Other Services</h2>
                    <span className="font-semibold">:</span>
                    <div className="flex gap-2 items-center flex-wrap w-[82%]">
                      {JSON.parse(dataResult.emrServices)
                        .filter(
                          (item) => item.GroupId !== 2 && item.GroupId !== 32,
                        )
                        .map((inv, index) => (
                          <div key={index}>
                            <div className="ml-2 font-semibold">
                              {inv?.Description || inv?.description}
                              {`${
                                JSON.parse(dataResult.emrServices).filter(
                                  (item) =>
                                    item.GroupId !== 2 && item.GroupId !== 32,
                                )?.length > 1 &&
                                index <
                                  JSON.parse(dataResult.emrServices).filter(
                                    (item) =>
                                      item.GroupId !== 2 && item.GroupId !== 32,
                                  )?.length -
                                    1
                                  ? "  |"
                                  : ""
                              }`}
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
            </div>
            <div>
              {dataResult?.emrAdvices && (
                <div className="text-[14px] flex">
                  <h2 className="font-semibold w-[16%]">Advices</h2>
                  <span className="font-semibold">:</span>
                  <div className="flex flex-wrap gap-2 items-center w-[82%]">
                    {JSON.parse(dataResult?.emrAdvices).map((adv, index) => (
                      <div key={index}>
                        <div className="ml-2 font-semibold">
                          {adv.description}
                          {`${
                            JSON.parse(dataResult?.emrAdvices)?.length > 1 &&
                            index <
                              JSON.parse(dataResult?.emrAdvices)?.length - 1
                              ? "  |"
                              : ""
                          }`}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div>
              {dataResult?.emrDiet && (
                <div className="text-[14px] flex">
                  <h2 className="font-semibold w-[16%]">Diet</h2>
                  <span className="font-semibold">:</span>
                  <div className="flex flex-wrap gap-2 items-center w-[82%]">
                    {JSON.parse(dataResult?.emrDiet).map((adv, index) => (
                      <div key={index}>
                        <div className="ml-2 font-semibold">
                          {adv.description}
                          {`${
                            JSON.parse(dataResult?.emrDiet)?.length > 1 &&
                            index < JSON.parse(dataResult?.emrDiet)?.length - 1
                              ? "  |"
                              : ""
                          }`}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className="text-[14px] flex space-x-2">
              <label className="font-semibold w-[16%]">Quick Notes</label>
              <div>: {dataResult?.importantNotes}</div>
            </div>
            <div>
              {dataResult?.newFollowupDate !== "" && (
                <div className="flex items-center text-[14px] w-full">
                  <h2 className="font-semibold w-[20%]">Next Followup Date</h2>
                  <div>: {dataResult?.newFollowupDate}</div>
                </div>
              )}
            </div>
            <div className="flex justify-end w-full pr-10 text-[12px]">
              <div>
                <div className="font-semibold">{dataResult?.Doctor}</div>
                <div>{dataResult?.Designation}</div>
                <div style={{ whiteSpace: "pre-wrap" }}>
                  {dataResult?.PrintSignature?.replaceAll("$", "\n")}
                </div>
              </div>
              {/* <div>
                <div className="font-semibold">Dr. Amit Majumdar</div>
                <div>M.B.B.S Medicine</div>
                <div style={{ whiteSpace: "pre-wrap" }}>
                </div>
              </div> */}
            </div>
            {/* <div>
                            {tempDetailsObj?.instructions && (
                                <div>
                                    <h2 className="font-semibold">Instruction</h2>
                                    <div>
                                        {tempDetailsObj?.instructions.map(
                                            (ins, index) => (
                                                <ul className="px key={index}>
                                                    <li className="list-disc">{ins}</li>
                                                </ul>
                                            )
                                        )}
                                    </div>
                                </div>
                            )}
                        </div> */}
          </div>
        </tbody>
        {/* <tfoot>
          <div className="">
            <img src={EMRFooter} />
          </div>
        </tfoot> */}
      </table>
    </div>
  );
}

export default EMRPrescriptionPrint;
